'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MiniCard = require('../MiniCard');

var _MiniCard2 = _interopRequireDefault(_MiniCard);

var _Ticker = require('../Ticker');

var _Ticker2 = _interopRequireDefault(_Ticker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MiniCardTicker = function MiniCardTicker(props) {
  var miniCardTickerTrack = function miniCardTickerTrack(type, data) {
    if (props.trackEvent) {
      props.trackEvent('mini_card_ticker_' + type, data);
    }
  };
  return _react2.default.createElement(
    _Ticker2.default,
    { trackEvent: miniCardTickerTrack, height: '128px' },
    props.cards.map(function (card) {
      return _react2.default.createElement(_MiniCard2.default, _extends({
        key: card.caption,
        linkProps: card.url && { url: card.url, trackEvent: miniCardTickerTrack }
      }, card));
    })
  );
};

MiniCardTicker.propTypes = {
  cards: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    caption: _propTypes2.default.string.isRequired,
    imgUrl: _propTypes2.default.string,
    url: _propTypes2.default.string
  })).isRequired,
  trackEvent: _propTypes2.default.func // eslint-disable-line react/no-unused-prop-types
};

MiniCardTicker.defaultProps = {
  trackEvent: null
};

exports.default = MiniCardTicker;